import type { FaroErrorBoundaryProps } from '@grafana/faro-react';
import { FaroErrorBoundary as FaroErrorBoundaryBase, faro } from '@grafana/faro-react';
import type { ComponentType } from 'react';

/**
 * Re-export FaroErrorBoundary with a React 19-compatible type cast.
 * The upstream class component types are incompatible with React 19's
 * stricter JSX element types (missing props/context). Runtime is fine.
 */
export const FaroErrorBoundary = FaroErrorBoundaryBase as unknown as ComponentType<FaroErrorBoundaryProps>;

/**
 * Push an error to Grafana Faro. Accepts `unknown` so call sites don't
 * need their own `instanceof Error` guard. Non-Error values are silently
 * ignored (they carry no useful stack trace).
 *
 * Client-only: this is a no-op on the server. Use `log.error` from
 * `server/lib/logger.ts` for server-side error reporting.
 */
export function pushError(error: unknown) {
  if (!(error instanceof Error)) return;
  faro?.api?.pushError(error);
}

export function pushEvent(name: string, attributes?: Record<string, string>) {
  faro?.api?.pushEvent(name, attributes);
}

export function setUser(user: { id: string; email: string }) {
  faro?.api?.setUser(user);
}

export function resetSession() {
  faro?.api?.resetSession();
}
